var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPitcairnIslands(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 397.384 397.384 512 256 512C114.616 512 0 397.384 0 256C0 256.061 256 0.028 256 0C397.384 0 512 114.616 512 256Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.315 256H256C256 255.77 256 255.546 256 255.315C255.772 255.544 255.544 255.772 255.315 256Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 133.565C256 88.52 256 59.005 256 0H255.957C114.591 0.024 0 114.629 0 256H133.565V180.789L208.776 256H255.316C255.544 255.772 255.772 255.544 256.001 255.315C256.001 238.068 256.001 222.679 256.001 208.778L180.788 133.565H256Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.515 33.391C89.4761 56.19 56.1891 89.476 33.3911 129.515V256H100.174V100.176V100.174H256C256 79.111 256 59.045 256 33.391H129.515Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 224.519L165.045 133.566H133.565V133.568L255.998 256H256C256 256 256 234.293 256 224.519V224.519Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.696 155.826L367.304 166.957L333.913 155.826L322.783 128L333.913 100.174H400.696L389.565 128L400.696 155.826Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.391 155.826V278.26C289.391 337.9 367.304 356.174 367.304 356.174C367.304 356.174 445.217 337.9 445.217 278.26V155.826H289.391Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.415 307.266C315.567 344.035 367.305 356.174 367.305 356.174C367.305 356.174 419.043 344.035 438.195 307.266L367.305 189.218L296.415 307.266Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.217 277.023L367.304 155.826L289.391 277.024V278.26C289.391 289.298 292.065 298.916 296.414 307.266L367.304 196.991L438.194 307.265C442.543 298.914 445.217 289.297 445.217 278.259V277.023Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitcairnIslands);
export default __webpack_public_path__ + "static/media/pitcairnIslands.5966ced79e7f8fd0eaf4dd79d3db8089.svg";
export { ForwardRef as ReactComponent };